import { trackInviteQrGenerated } from "../analytics/bridges/inviteAnalytics";

/**
 * Download a QR code PNG from a canvas element (e.g. qrcode.react QRCodeCanvas).
 * @param {HTMLCanvasElement | null} canvas
 * @param {string} [filename]
 * @param {"roster"|"spectator"} [inviteChannel] omit for TV (not instrumented in MVP slice)
 * @returns {boolean}
 */
export function downloadMatchQrPng(
  canvas,
  filename = "TheRallyAlly-match-qr.png",
  inviteChannel
) {
  if (!canvas || typeof canvas.toDataURL !== "function") return false;
  try {
    const link = document.createElement("a");
    link.download = filename;
    link.href = canvas.toDataURL("image/png");
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (inviteChannel) trackInviteQrGenerated(inviteChannel);
    return true;
  } catch {
    return false;
  }
}

/**
 * Safe filename slug for room code in downloads.
 * @param {string} roomCode
 */
export function matchQrDownloadFilename(roomCode, kind = "join") {
  const slug = (roomCode || "match").replace(/[^\w-]+/g, "-").slice(0, 48);
  const suffix = kind === "tv" ? "tv-qr" : "qr";
  return `TheRallyAlly-${slug}-${suffix}.png`;
}
